import React from "react";
import outline from "../../assets/icons/home_help.svg";
// import award_1 from "../../assets/icons/award-1-01.svg";
// import award_2 from "../../assets/icons/award-2-01.svg";
// import award_3 from "../../assets/icons/award-3-01.svg";
// import award_4 from "../../assets/icons/award-4-01.svg";
// import award_5 from "../../assets/icons/award-5-01.svg";
// import award_6 from "../../assets/icons/award-6-01.svg";

const AboutEducation = () => {
  const education = [
    {
      id: 1,
      title: "Bachelor of Medicine & Bachelor of Surgery ( MBBS)",
      University: " Guntur Medical College (Gold Medalist)",
      timeline: "Jan 2014 - Dec 2018",
    },

    {
      id: 4,
      title: "FIAGES ",
      University:
        "Fellow of the Indian Association of Gastrointestinal Endo Surgeons",
      timeline: "Jan 2014 - Dec 2018",
    },
    {
      id: 2,
      title: "M.S. (General Surgery)",
      University: "Kasturba Medical College, Mangalore (Gold Medalist)",
      timeline: "Jan 2014 - Dec 2018",
    },
    {
      id: 3,
      title: "M.Ch. (Surgical Oncology)",
      University: "Cancer Institute (WIA), Adyar, Chennai",
      timeline: "Jan 2014 - Dec 2018",
    },
  ];
  // const awards = [
  //   {
  //     id: 1,
  //     title: "",
  //     icon: award_1,
  //   },
  //   {
  //     id: 2,
  //     title: "",
  //     icon: award_2,
  //   },
  //   {
  //     id: 3,
  //     title: "",
  //     icon: award_3,
  //   },
  //   {
  //     id: 4,
  //     title: "",
  //     icon: award_4,
  //   },
  //   {
  //     id: 5,
  //     title: "",
  //     icon: award_5,
  //   },
  //   {
  //     id: 6,
  //     title: "",
  //     icon: award_6,
  //   },
  // ];
  return (
    <div className="xl:py-28 lg:py-20 md:py-14 py-10 relative overflow-hidden">
      <div className="bottom-0  left-0  absolute">
        <img src={outline} alt="outline" className="pointer-events-none" />
      </div>
      <div data-aos="fade-up" className="xl:w-[1280px] 2xl:px-0 xl:px-10 px-0 w-11/12 mx-auto flex justify-center items-center flex-col z-10">
        <span className="text-xl font-medium text-[#1d9e75] uppercase border-b border-[#B87333]  px-2 py-1.5 ">
          My Qualification
        </span>
        <h2 className="lg:text-4xl md:text-3xl text-xl text-center font-bold mt-2 text-matcha leading-tight">
          My Qualification & Awards
        </h2>
        <div className="grid relative  md:grid-cols-2 grid-cols-1 w-full gap-5 md:gap-10 mt-16">
          {education.map((item, index) => (
            <div
              key={item.title}
              className="flex flex-col p-6 gap-1 bg-almond rounded-xl"
            >
              <h3 className="text-xl font-bold text-matcha">{item.title}</h3>
              <h3 className="text-base font-bold text-[#1d9e75] ">
                {item.University}
              </h3>
              <p className="text-base text-[#B87333]  font-medium">
                {item.timeline}
              </p>
            </div>
          ))}
        </div>
        {/* <div className="w-full bg-matcha p-6  grid lg:grid-cols-6 md:grid-cols-3 grid-cols-2 rounded-xl gap-8 relative mt-12 ">
          {awards.map((item) => (
            <div
              key={item.icon}
              className="flex justify-center items-center py-3"
            >
              <img src={item.icon} alt="" className="w-28" />
            </div>
          ))}
        </div> */}
      </div>
    </div>
  );
};

export default AboutEducation;
